/**
 * Featured Bottles Add to Cart Handler
 * Handles adding products to cart from the featured bottles section
 */

document.addEventListener("DOMContentLoaded", function () {
  // Find all add to cart buttons in featured bottles section
  const addToCartButtons = document.querySelectorAll(
    ".featured-bottle-card__button--add-to-cart",
  );

  addToCartButtons.forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation(); // Prevent the link from navigating

      const variantId = this.getAttribute("data-product-id");

      if (!variantId) {
        console.error("No variant ID found for this product");
        return;
      }

      // Use the theme's addToCartJS function if available (handles cart drawer, sections, etc.)
      if (typeof addToCartJS === "function") {
        this.classList.add("loading");
        addToCartJS(1, variantId, this);
        return;
      }

      // Fallback: direct fetch with correct headers
      const originalText = this.textContent;
      this.textContent = "Adding...";
      this.style.pointerEvents = "none";

      fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers:  {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          quantity: 1,
          id: parseInt(variantId),
        }),
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then((err) => {
              throw new Error(err.description || "Failed to add to cart");
            });
          }
          return response.json();
        })
        .then((data) => {
          this.textContent = "Added!";

          // Open cart drawer if it exists
          if (typeof openCartDrawer === "function") {
            openCartDrawer();
          }

          // Reset button after 2 seconds
          setTimeout(() => {
            this.textContent = originalText;
            this.style.pointerEvents = "auto";
          }, 2000);
        })
        .catch((error) => {
          console.error("Error adding to cart: ", error);
          alert(
            error.message ||
              "There was an error adding this item to your cart.",
          );
          this.textContent = originalText;
          this.style.pointerEvents = "auto";
        });
    });
  });
});
